const COOKIE = "attnd_consent";
const MAX_AGE = 60 * 60 * 24 * 180;
const EVENT = "attnd-consent";

function cookieDomain() {
  if (typeof window === "undefined") return "";
  const host = window.location.hostname;
  if (host === "attnd.sa" || host.endsWith(".attnd.sa")) return "; Domain=.attnd.sa";
  return "";
}

export function readConsent() {
  if (typeof document === "undefined") return null;
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const part of parts) {
    if (!part.startsWith(`${COOKIE}=`)) continue;
    const value = decodeURIComponent(part.slice(COOKIE.length + 1));
    if (value === "accepted" || value === "rejected") return value;
  }
  try {
    const stored = localStorage.getItem(COOKIE);
    if (stored === "accepted" || stored === "rejected") return stored;
  } catch {
    // private mode
  }
  return null;
}

export function hasConsent() {
  return readConsent() === "accepted";
}

export function writeConsent(value) {
  if (value !== "accepted" && value !== "rejected") return;
  if (typeof document !== "undefined") {
    document.cookie = `${COOKIE}=${encodeURIComponent(value)}; Path=/; Max-Age=${MAX_AGE}; SameSite=Lax${cookieDomain()}`;
  }
  try {
    localStorage.setItem(COOKIE, value);
  } catch {
    // the cookie still holds the choice on attnd.sa
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event(EVENT));
}

export function subscribeConsent(listener) {
  if (typeof window === "undefined") return () => {};
  const onChange = () => listener(readConsent());
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
}

export function bannerCopy() {
  const lang = typeof document !== "undefined" ? document.documentElement.lang : "";
  let stored = "";
  try {
    stored = localStorage.getItem("language") || "";
  } catch {
    // ignore
  }
  if (lang.startsWith("ar") || stored.startsWith("ar")) {
    return {
      body: "نستخدم ملفات تعريف الارتباط لقياس زيارات الموقع وتذكّر هذا الاختيار.",
      accept: "قبول",
      reject: "رفض",
    };
  }
  return {
    body: "We use cookies to measure site visits and remember this choice.",
    accept: "Accept",
    reject: "Reject",
  };
}
